import React, {Component} from 'react';
import {CurrencySelect} from "./CurrencySelect";

class BudgetValueInput extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currency: this.props.budgetCurrency,
            amount: this.props.budgetAmount,
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.budgetAmount !== this.props.budgetAmount) {
            this.setState({ amount: this.props.budgetAmount });
        }
    }

    handleCurrencyChange = (event) => {
        const newCurrency = event.target.value
        this.setState({currency: newCurrency});
        if (this.props.onCurrencyChange) {
            this.props.onCurrencyChange(newCurrency)
        }
    };

    handleAmountChange = (event) => {
        const possibleNewValue = parseFloat(event.target.value.replace(/\D/g, '')); // Remove non-digit characters
        let newValue = event.target.value;
        if (!isNaN(possibleNewValue)) {
            newValue = possibleNewValue;
        }

        this.setState({amount: newValue});
        if (this.props.onAmountChange) {
            this.props.onAmountChange(newValue);
        }
    };

    // renderChoiceOtherCurrencyMessage() {
    //     if (!this.props.canEditCurrency) {
    //         return <a href="https://ayuda.dashbo.io/" rel="noopener noreferrer" target="_blank"
    //                   className="field-footnote pb-0 mb-0">Elegir otra moneda</a>
    //     }
    // }

    getCanEditCurrency() {
        return this.props.canEditCurrency ? this.props.canEditCurrency : false;
    }

    renderCurrencySelect() {
        const showCurrency = !(this.props.hideCurrency === true);
        if (showCurrency) {
            return  <div className="col-md-4">
                        <CurrencySelect name="currency"
                                    required="required"
                                    selected={this.state.currency}
                                    onChange={this.handleCurrencyChange}
                                    readOnly={(this.props.currencyReadOnly === true || this.props.readOnly || !this.getCanEditCurrency())}

                        />
            </div>
        }
    }

    getAmountInputColumnSize() {
        const showCurrency = !(this.props.hideCurrency === true);

        if (showCurrency) {
            return "8";
        } else {
            return "12";
        }
    }

    render() {
        let formattedValue;
        if (this.state.amount || this.state.amount === 0) {
            formattedValue = Number(this.state.amount).toLocaleString('en-US');
        } else {
            formattedValue = '';
        }

        if(this.props.onlyCurrencySelect === true)
            return (<div className="row g-2 mb-0">{this.renderCurrencySelect()}</div>);

        return (
            <div className="row g-2 mb-0">
                {this.renderCurrencySelect()}
                <div className={"col-md-"+this.getAmountInputColumnSize()}>
                    <input
                        min="1"
                        name="budget_amount"
                        type="text"
                        className={this.getAmountClassName()}
                        id="amount"
                        value={formattedValue}
                        onChange={this.handleAmountChange}
                        required="required"
                        readOnly={(this.props.readOnly === true)}
                    />
                    {/*{this.renderChoiceOtherCurrencyMessage()}*/}
                </div>
            </div>
        );
    }

    getAmountClassName() {
        if(this.props.amountClassName === undefined) {
            return "form-control";
        }

        return `form-control ${this.props.amountClassName}`;
    }
}

export default BudgetValueInput;
